















/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator';
import Tab from '@/components/Tab.vue';
import TabPanel from '@/components/TabPanel.vue';
import HandleTypeC from './components/HandleType.vue';
import AlarmListPanel from './components/AlarmListPanel.vue';
import Radio from '@/components/Radio.vue';
import CheckBox from '@/components/CheckBoxC.vue';

@Component({
  components: {
    'rap-tab': Tab,
    'rap-tab-panel': TabPanel,
    'handle-type': HandleTypeC,
    'alarm-list-panel': AlarmListPanel,
    'rap-radio': Radio,
    'rap-checkbox': CheckBox,
  },
})
export default class AlarmDetail extends Vue {
  private handleList: any[] = [];
  private handleStatus = 0;
  private isAllSelected = false;
  private tabSwitch(index: number): void {
    this.handleStatus = index === 1 ? 2 : 0;
  }
  private listChange(list: any[]): void {
    this.handleList = list;
  }
  private allSelected(checked: boolean): void {
    this.isAllSelected = checked;
  }
}
